import React from "react";
import styles from "./TableWidgets.module.scss"

export default ({children, style}) => {
    return <div className={styles.base} style={style}>
        {children}
    </div>
};
